module.exports = __webpack_public_path__ + "media/images/talent/voice-icon-arrow-f08af4e67aaed348c14a07f6282d91a2.png";